export const user = [
  {
    id: 1,
    name: "Hailee",
    profilepicture: "assets/profile/profileimg1.png",
  },
  {
    id: 2,
    name: "Timothy",
    profilepicture: "assets/profile/profileimg2.jpg",
  },
  {
    id: 3,
    name: "Bruce",
    profilepicture: "assets/profile/profileimg3.jpg",
  },
  {
    id: 4,
    name: "Catylyn",
    profilepicture: "assets/profile/profileimg4.webp",
  },
  {
    id: 5,
    name: "suzan",
    profilepicture: "assets/profile/profileimg1.png",
  },
  {
    id: 6,
    name: "Todd",
    profilepicture: "assets/profile/profileimg1.png",
  },
  {
    id: 7,
    name: "Gregory",
    profilepicture: "assets/profile/profileimg1.png",
  },
];
export const posts = [
  {
    id: 1,
    desc: "Love and peace",
    photo: "assets/post/postimg1.png",
    dates: "5 min ago",
    userId: 1,
    like: 32,
    comments: 9,
  },
  {
    id: 2,
    desc: "whatever bro",
    photo: "assets/post/postimg2.jpg",
    dates: "2 days ago",
    userId: 2,
    like: 30502,
    comments: 299,
  },
  {
    id: 3,
    desc: "nice day",
    photo: "assets/post/profileimg4.jpg",
    dates: "50 min ago",
    userId: 3,
    like: 320,
    comments: 19,
  },
  {
    id: 4,
    desc: "hi",
    photo: "assets/post/postimg5.jpg",
    dates: "55 min ago",
    userId: 4,
    like: 2,
    comments: 9,
  },
];
